<script>
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	export let data;
	let scale = 1;

	$: {
		if(data.iconSize){
		scale = data.iconSize.slice(1);
		}
	}

	const click = () => {
		dispatch("click");
	}
	let video;

	const vids = {mp4:"mp4",avi:"avi",mpg:"mpg",mpeg:"mpeg",webm:"webm"}

	if(data.videoBubbleUrl.split('.').pop() in vids){
		setInterval(() => {
			video.play();
		}, 300);
	}

</script>

<div class="chatwith-videobubble"  on:click="{() => click()}"
	style="width:{scale*150}px;height:{scale*150}px;" >
	{#if data.videoBubbleUrl.split('.').pop() in vids}
	<video
		style="width:{scale*150+10}px;height:{scale*150+10}px;"
		src={data.videoBubbleUrl}
		bind:this={video}
		playsinline
		loop
		muted
	>
		<track kind="captions"/>
	</video>
	{:else}
	<img
		class="chatwith-img"
		style="width:{scale*150+10}px;height:{scale*150+10}px;"
		alt="tochat-whatsapp"
		src={data.videoBubbleUrl
		? data.videoBubbleUrl
		: "https://widget.tochat.be/icon-1.png"}
	/>
	{/if}
</div>

<style>
	.chatwith-videobubble{
		position:relative;
		justify-content: center;
    	display: flex;
		border-radius: 150px;
		top: -10px;
  		left: -10px;
		mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
		cursor: pointer;
		transform: translate(-10%, -10%);
 		transition: 0.3s all ease-in-out;
		margin-top: 50px;
	}

	.chatwith-videobubble:hover{
		transform: scale(1.1) translate(-10px,-10px);
	}
	.chatwith-videobubble video ,
	.chatwith-videobubble img {
		top: 0;
		bottom:0;
		left:0;
		right:0;
		position:absolute;
		object-fit: cover;

	}
</style>
